import { render, staticRenderFns } from "./importarrival.vue?vue&type=template&id=524cdf62&scoped=true&"
import script from "./importarrival.vue?vue&type=script&lang=js&"
export * from "./importarrival.vue?vue&type=script&lang=js&"
import style0 from "./importarrival.vue?vue&type=style&index=0&id=524cdf62&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524cdf62",
  null
  
)

export default component.exports